import React, { useState } from "react";
import "./file-tree.css";

function TreeNode({ file, setActiveFile, activeFile, onClickRow }) {
    const [collapsed, setCollapsed] = useState(true);
    const liClassName = file.hasChildren ? "parent-node" : "child-node";

    const toggleCollapse = () => {
        setCollapsed(!collapsed);
        if(collapsed) {
            setActiveFile(file.alias);
            onClickRow(file); 
        }
    };

    const handleClick = () => {
        setActiveFile(file.alias);
        onClickRow(file);
    };

    return (
        <>
            <li className={`${liClassName} ${activeFile === file.alias ? " active" : ""}`}>
                {file.hasChildren == true && (
                    <em
                        onClick={toggleCollapse}
                        className={`expand la la-angle-${collapsed ? "right" : "down"}`}
                    ></em>
                )}

                <div className="li-full-row" onClick={handleClick}></div>
                <div className="li-text-content">
                    <em className="fa fa-folder">
                    {file.isShared ? <em className="la la-user-friends shared"></em> : null}
                    </em>
                   
                    <span>{file.name}</span>
                </div>
            </li>

            {file.hasChildren == true && !collapsed && (
                <ul className="child-parent-container">
                    {file.children?.filter((item) => item.isFolder)
                        .map((childFile) => (
                            <TreeNode
                                key={childFile.alias}
                                file={childFile}
                                setActiveFile={setActiveFile}
                                activeFile={activeFile}
                                onClickRow={onClickRow}
                            />
                        ))}
                </ul>
            )}
        </>
    );
}

function FileTree({ files, onSelectedRow }) {
    const [activeFile, setActiveFile] = useState(null);
    return (
        <div className="file-manager__body-tree">
            <ul className="parent-container">
                {files
                    .filter((item) => item.isFolder)
                    .map((file) => (
                        <TreeNode
                            key={file.alias}
                            file={file}
                            setActiveFile={setActiveFile}
                            activeFile={activeFile}
                            onClickRow={onSelectedRow}
                        />
                    ))}
            </ul>
        </div>
    );
}

export default FileTree;
